import { HttpClient, type RpcMethod, type RpcParams, type RpcResult } from '@chainflip/rpc';
import { type CfAccountInfo } from '@chainflip/rpc/types';
import { WsProvider, ApiPromise } from '@polkadot/api';

export const humanReadableRole: Record<CfAccountInfo['role'], string> = {
  broker: 'Broker',
  liquidity_provider: 'Liquidity Provider',
  validator: 'Validator',
  operator: 'Operator',
  unregistered: 'Unregistered',
};

export const initRpcWsConnection = async () => {
  try {
    const wsProvider = new WsProvider(process.env.NEXT_PUBLIC_STATECHAIN_RPC_WS_URL as string);
    const api = await ApiPromise.create({ provider: wsProvider, noInitWarn: true });
    return api.isReady;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error connecting to rpc', error);
    throw error;
  }
};

const client = new HttpClient(process.env.NEXT_PUBLIC_STATECHAIN_RPC_HTTP_URL as string);

export default async function makeRpcRequest<M extends RpcMethod>(
  method: M,
  ...args: RpcParams[M]
): Promise<RpcResult<M>> {
  try {
    return await client.sendRequest(method, ...args);
  } catch (error) {
    throw new Error(`Error calling rpc method ${method}(${JSON.stringify(args)}): ${error}`);
  }
}
